import Vue from 'vue'
import Router from 'vue-router'

// Containers
import Full from '@/containers/Full'

// Views - Icons
import FontAwesome from '@/views/icons/FontAwesome'
import SimpleLineIcons from '@/views/icons/SimpleLineIcons'

// Views - Pages
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'
import Login from '@/views/pages/Login'
import Register from '@/views/pages/Register'

// Views - Distribuidores
import Distribuidores from '@/views/Distribuidores/Distribuidores'
import Distribuidor from '@/views/Distribuidores/Distribuidor'

// Views - Contribuyentes
const Contribuyentes = () => import(/* webpackChunkName: "home" */ '@/views/Contribuyentes/Contribuyentes')
const Contribuyente = () => import(/* webpackChunkName: "home" */ '@/views/Contribuyentes/Contribuyente')

const Asignaciones = () => import(/* webpackChunkName: "home" */ '@/views/Asignaciones/Asignaciones')
const AsignacionesEspeciales = () => import(/* webpackChunkName: "home" */ '@/views/Asignaciones/Especiales/Asignaciones')
const AsignacionesEspecialesTwo = () => import(/* webpackChunkName: "home" */ '@/views/Asignaciones/EspecialesTwo/Asignaciones')

const Compras = () => import('@/views/Compras/Compras')

Vue.use(Router)

export default new Router({
  mode: 'hash', // Demo is living in GitHub.io, so required!
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/distribuidores',
      name: 'Facturando',
      component: Full,
      children: [
        {
          path: 'distribuidores',
          redirect: '/distribuidores',
          name: 'Lista de distribuidores',
          meta: {conditionalRoute: true},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: ' ',
              component: Distribuidores
            },
            {
              path: ':id',
              name: 'Distribuidor',
              component: Distribuidor
            }
          ]
        },
        {
          path: 'contribuyentes',
          name: 'Lista de contribuyentes',
          redirect: '/contribuyentes',
          meta: {conditionalRoute: true},
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: '',
              name: 'contribuyentes',
              component: Contribuyentes
            },
            {
              path: ':id',
              name: 'Contribuyente',
              component: Contribuyente
            }
          ]
        },
        {
          path: 'asignaciones',
          name: 'Historial de Asignaciones',
          meta: {conditionalRoute: true},
          component: Asignaciones
        },
        {
          path: 'compras',
          name: 'Historial de Compras',
          meta: {conditionalRoute: true},
          component: Compras
        },
        {
          path: 'asignaciones-especiales',
          name: 'Asignaciones Esp',
          meta: {conditionalRoute: true},
          component: AsignacionesEspeciales
        },
        {
          path: 'icons',
          redirect: '/icons/font-awesome',
          name: 'Icons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'font-awesome',
              name: 'Font Awesome',
              component: FontAwesome
            },
            {
              path: 'simple-line-icons',
              name: 'Simple Line Icons',
              component: SimpleLineIcons
            }
          ]
        },
        {
          path: 'asignaciones-especiales-2',
          name: 'Asignaciones Esp 2',
          meta: {conditionalRoute: true},
          component: AsignacionesEspecialesTwo
        }
      ]
    },
    {
      path: '/',
      redirect: '/p404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js